import React from "react";
import "./thirdpage.css"
import { useNavigate } from "react-router-dom";


const ThirdPage = () => {

   const navigate = useNavigate();

   const handleClick = () => {
      navigate("/fourthPage");
   };
   
    return (
       <>
        <h1 onClick={handleClick}>hii</h1>
       </>
    );
   };
   
   export default ThirdPage;
   